export default {
  PromoCode__APPLY: "Apply",
  PromoCode__CAPTION_DESCRIPTION: "Wanna getaway? Use an available code to get away for less.",
  PromoCode__CAPTION_TITLE: "Use a Promotional Code",
  PromoCode__EDIT_PROMO_CODE: "Edit Promo Code",
  PromoCode__FORM_FIELD_CAPTION: "Maximum one (1) promo code can be applied",
  PromoCode__USE_PROMO_CODE: "Use Promo Code",
};
